/**
 * @generated SignedSource<<e2e9668cc972211a7a4d4034989a4f6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetFlexiUnitArticleLabelArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetFlexiUnitArticleLabelArticle";
};
export type helpersGetFlexiUnitArticleLabelArticle$key = {
  readonly " $data"?: helpersGetFlexiUnitArticleLabelArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetFlexiUnitArticleLabelArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetFlexiUnitArticleLabelArticle"
};

(node as any).hash = "e1529bfa382be0a7de0fcbdd6d100831";

export default node;
